module.exports = __webpack_public_path__ + "img/ManufactureButton.66a2aef3.png";